import shared from '../../pages/00_resumes/SharedCSS.module.css';
import resume from '../../pages/00_resumes/resume/Resume.module.css'
import rlresume from '../../pages/00_resumes/RLresume/RLresume.module.css'
import { useLocation } from 'react-router-dom';

function BulletPercentage({ title = "Skill", percentage = 0, total = 10 }) {
  const filledCount = Math.round((percentage / 100) * total);

  const { pathname } = useLocation();
  const isResume = pathname === '/resume';
  const isRL = pathname === '/real-life-resume';

  return (
    <div className={shared.bulletWrapper}>
      <div className={shared.bulletTitle}>{title}</div>
      <div className={shared.bulletContainer}>
        {Array.from({ length: total }).map((_, index) => (
          <span
            key={index}
            className={`${shared.bulletDot} ${isResume ? resume.bulletDot : ''} ${isRL ? rlresume.bulletDot : ''} ${isResume && index < filledCount ? resume.bulletDotFilled : ''} ${isRL && index < filledCount ? rlresume.bulletDotFilled : ''}`}
          />
        ))}
      </div>
    </div>
  );
}

export default BulletPercentage;
